import { isElementNode, isTag } from 'anodum';

const normalizeCollapsedSelection = ({ node, offset }) => {
  if (isElementNode(node) && !isTag(node, 'br') && node.childNodes.length) {
    const childByIndex = node.childNodes[offset];
    return { node: childByIndex, offset: 0 };
  }
  return { node, offset };
};

export default normalizeCollapsedSelection;
